import { Button, Dropdown } from '@ibsys/kit';
import { DownloadIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { FileDownloadFormat } from '@/shared/lib';

type Props = {
  /** Выгрузка в выбранном формате */
  onDownload: (format: FileDownloadFormat) => void;
  /** Файл формируется — повторное скачивание не запускается */
  isPending: boolean;
  /** Классы кнопки-триггера */
  className?: string;
};

/** Форматы файла в порядке показа в выпадающем списке */
const DOWNLOAD_FORMATS: FileDownloadFormat[] = ['docx', 'pdf', 'xlsx'];

/**
 * Кнопка скачивания файлом: иконка загрузки, по клику — выпадающий список форматов.
 * Единая точка выбора формата для всех выгрузок (транскрипция, заключение, список диалогов).
 */
export const DownloadFormatButton: FC<Props> = ({ onDownload, isPending, className }) => {
  const { t } = useTranslation(['dialogs', 'common']);

  return (
    <Dropdown
      options={DOWNLOAD_FORMATS.map((format) => ({
        key: format,
        title: t('dialogs:downloadFormat', { format: `.${format}` }),
        type: 'item' as const,
        onClick: () => onDownload(format),
      }))}
    >
      <Button
        variant="ghost"
        size="icon"
        className={className}
        aria-label={t('common:download')}
        disabled={isPending}
        icon={<DownloadIcon className="size-4" />}
      />
    </Dropdown>
  );
};
